export default "__VITE_ASSET__D3mEtX8z__"